/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import PropTypes from 'prop-types';
import React     from 'react';

export default function Icon(props) {
  let attributes = {
    width: props.width,
    height: props.height,
    fill: props.fill ? props.fill : null
  };

  let path = '#' + props.name;

  return (
    <svg {...attributes} fill={props.fill ? props.fill : null }>
      <use xlinkHref={`${path}`} />
    </svg>
  );
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  fill: PropTypes.string,
};
